import { useState } from 'react';
import { Sparkles, Minus, Maximize } from 'lucide-react';
import { useNavigate } from '@tanstack/react-router';
import ChatPage from '../../pages/ChatPage/ChatPage';
import { Button } from '../../components/ui/button';

const FloatingChatWidget = () => {
    const [isOpen, setIsOpen] = useState(false);
    const navigate = useNavigate();

    const toggleChat = () => setIsOpen(!isOpen);

    if (!isOpen) {
        return (
            <Button
                onClick={toggleChat}
                className="fixed bottom-8 right-8 bg-primary text-white rounded-full w-16 h-16 shadow-lg flex items-center justify-center z-50"
                aria-label="Open chat"
            >
                <Sparkles size={80} />
            </Button>
        );
    }

    return (
        <div className="fixed bottom-8 right-8 w-100 h-150 bg-neutral-50 rounded-2xl shadow-2xl flex flex-col z-50 border border-neutral-300">
            <div className="flex justify-between items-center p-4 bg-neutral-100 rounded-t-2xl">
                <h3 className="font-bold text-lg">Ask Rukia</h3>
                <div className="flex items-center gap-2">
                    <Button onClick={() => navigate({ to: '/chat' })} variant="ghost" aria-label="Open full chat page">
                        <Maximize size={18} />
                    </Button>
                    <Button onClick={toggleChat} variant="ghost" size="icon">
                        <Minus size={20} />
                        <span className="sr-only">Minimize chat</span>
                    </Button>
                </div>
            </div>
            <div className="grow overflow-hidden">
                <ChatPage
                    initialMessage=""
                    showIntroMessage={true}
                    apiEndpoint={`${import.meta.env.VITE_AI_AGENT_API_URL}/teaching-assistant`}
                    getApiPayload={userQuestion => JSON.stringify({ question: userQuestion })}
                />
            </div>
        </div>
    );
};

export default FloatingChatWidget;
